// extracted by mini-css-extract-plugin
module.exports = {"zoneTypeStyle":"_2Hcbo6C_EKOrVwD22HKWrg"};